"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConfigSet_1 = require("./ConfigSet");
var AsyncConfigSet_1 = require("./AsyncConfigSet");
var ConfigManager = /** @class */ (function () {
    function ConfigManager() {
        this.interceptors = [];
    }
    ConfigManager.prototype.addInterceptor = function (interceptor) {
        this.interceptors.push(interceptor);
        return this;
    };
    ConfigManager.prototype.getInterceptors = function () {
        return this.interceptors;
    };
    ConfigManager.prototype.setQueryContextProvider = function (contextProvider) {
        this.queryContextProvider = contextProvider;
        return this;
    };
    ConfigManager.prototype.setWeblabContextProvider = function (weblabContextProvider) {
        this.weblabContextProvider = weblabContextProvider;
        return this;
    };
    ConfigManager.prototype.createConfigSet = function (configStore) {
        return new ConfigSet_1.ConfigSetImpl(configStore, this.interceptors, this.queryContextProvider, this.weblabContextProvider);
    };
    ConfigManager.prototype.createAsyncConfigSet = function (configStore) {
        return new AsyncConfigSet_1.ConfigSetImplAsync(configStore, this.interceptors, this.queryContextProvider, this.weblabContextProvider);
    };
    return ConfigManager;
}());
exports.default = ConfigManager;
